<script setup>
  import { ref } from "vue";
  import { useUserStore } from "@/stores/UserStore";
  import { useSheetController } from '@/composables/useSheetsController';
  import MapSourceSelectorBase from "@/components/MapSourceSelectorBase.vue";
  import Icon from "./icons/Icon.vue";
  
  const userStore = useUserStore();

  let isLoading = ref(true);

  await userStore.getProfiles();

  isLoading.value = false;

  function handleShowModelSheet() {
    useSheetController.toggleSheet('source', 'user-profiles', true);
  }

</script>

<template>
  <MapSourceSelectorBase
    @showSheet="handleShowModelSheet"
  >
    <template #icon>
      <Icon name="star" />
    </template>
    <template #label>
      {{ userStore.currentProfile.name }}
    </template>
    <template #badge>
      <span class="jwx-source-selector__meta jwx-source-selector__meta--pill">{{ userStore.currentProfile.favorite_spots.length }}</span>
    </template>
  </MapSourceSelectorBase>
</template>